<template>
  <div>
    <!-- 上传插件的对话框 -->
    <el-dialog title="上传插件" :visible.sync="dialog.visible" width="40%" append-to-body :modal-append-to-body="false"
      @closed="closed" :close-on-click-modal="true">
      <div>
        <!-- 表单 -->
        <el-form ref="form" :disabled="dialog.disabled" :model="form" :rules="rules" label-width="150px">
          <!-- 上传插件 -->
          <el-form-item label="插件上传：" prop="fileUrl">
            <el-upload v-if="!form.fileUrl" :before-upload="checkUpload" :http-request="upload" :show-file-list="false">
              <el-button size="small" type="primary" :loading="uploadBtnLoading">上传插件</el-button>
            </el-upload>
            <span v-if="form.fileUrl">{{ currentUploadFileName }}</span>
          </el-form-item>
          <!-- 插件ID -->
          <el-form-item label="插件ID：" prop="code">
            <el-input clearable v-model="form.code" placeholder="请输入插件ID" maxlength="64" size="small"></el-input>
          </el-form-item>
          <!-- 插件名称 -->
          <el-form-item label="插件名称：" prop="name">
            <el-input clearable v-model="form.name" placeholder="请输入插件名称" maxlength="32" size="small"></el-input>
          </el-form-item>
          <el-form-item label=" " style="height: 20px;line-height: 20px;">
            <span>说明: 如若插件ID与已有插件ID重复，名称将会进行覆盖</span>
          </el-form-item>
          <!-- 插件描述 -->
          <el-form-item label="更新说明：" prop="descr">
            <el-input clearable v-model="form.descr" placeholder="请输入插件描述" maxlength="128" size="small"></el-input>
          </el-form-item>
          <!-- 插件版本 -->
          <el-form-item label="插件版本：" prop="ver">
            <el-input clearable v-model="form.ver" placeholder="请输入插件版本" maxlength="16" size="small"></el-input>
          </el-form-item>
          <!-- 支持APP版本 -->
          <el-form-item label="支持APP版本：" prop="appVer">
            <div style="display: flex;">
              <el-input-number :precision="0" style="margin-right: 10px; width: 180px;" v-model="form.appVer"
                label="描述文字"></el-input-number>
              <el-input-number v-model="form.appVerMax" label="描述文字" />
            </div>
          </el-form-item>
          <el-form-item style="margin-top: -10px; margin-bottom: 0px" label=" ">
            <div style="display: flex;">
              <div style="
                width: 180px;
                text-align: center;
                display: inline-block;
                color: #a7a7a7;
                margin-right: 10px;
              ">
                最小版本
              </div>
              <div style="
                width: 180px;
                text-align: center;
                display: inline-block;
                color: #a7a7a7;
              ">
                最大版本
              </div>
            </div>
          </el-form-item>
          <!-- 支持SDK版本 -->
          <el-form-item label="支持SDK版本：" prop="sdkVer">
            <div style="display: flex;">
              <el-input-number style="margin-right: 10px; position: relative" v-model="form.sdkVer"
                label="描述文字"></el-input-number>
              <el-input-number v-model="form.sdkVerMax" label="描述文字" />
            </div>
          </el-form-item>
          <el-form-item style="margin-top: -10px; margin-bottom: 0px" label=" ">
            <div style="display: flex;">
              <div style="
                width: 180px;
                text-align: center;
                display: inline-block;
                color: #a7a7a7;
                margin-right: 10px;
              ">
                最小版本
              </div>
              <div style="
                width: 180px;
                text-align: center;
                display: inline-block;
                color: #a7a7a7;
              ">
                最大版本
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" style="flex-end">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="confirm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addPlugins } from "@/api/pluginManage/pluginConfig";
import Message from "@/components/Message";
import OSS from "ali-oss";
import moment from 'moment';
import { handleAddData } from '../utils/index.js';

export default {
  name: "WebSaaSAdd",
  inject: ['loadList', 'aliyunAkSk'],
  data() {
    return {
      client: null,
      /** 对话框 */
      dialog: {
        visible: false,
        disabled: false,
      },
      // zip的MIME类型
      validMimeTypes: [
        "application/zip",
        "application/x-zip-compressed",
        "multipart/x-zip",
      ],
      // 上传按钮的loading
      uploadBtnLoading: false,
      // 表单
      form: {
        // 插件ID
        code: "",
        // 插件名称
        name: "",
        // 插件描述
        descr: "",
        // 插件大小
        fileSize: "",
        // 插件版本
        ver: "",
        // 支持APP版本
        appVer: "",
        appVerMax: "",
        // 支持SDK版本
        sdkVer: "",
        sdkVerMax: "",
        // 文件md5
        fileMd5: "",
        // 文件地址
        fileUrl: "",
      },
      // 当前上传文件名
      currentUploadFileName: "",
      // 表单验证规则
      rules: {
        code: [{
          required: true, trigger: "blur",
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error("请输入插件ID"));
            }
            // 支持中文、英文、数字、下划线
            const reg = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
            if (!reg.test(value)) {
              return callback(new Error("请输入中文、英文、数字、下划线的组合"));
            }
            callback();
          }
        }],
        name: [{
          required: true, trigger: "blur",
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error("请输入插件名称"));
            }
            callback();
          }
        }],
        descr: [{
          required: true, trigger: "blur",
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error("请输入插件描述"));
            }
            callback();
          }
        }],
        ver: [{
          required: true, trigger: "blur",
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error("请输入插件版本"));
            }
            // 支持正整数
            const reg = /^[1-9]\d*$/;
            if (!reg.test(value)) {
              return callback(new Error("请输入正整数"));
            }
            callback()
          }
        }],
        appVer: [{
          required: false, trigger: "blur",
          validator: (rule, value, callback) => {
            if ((!this.form.appVer && !this.form.appVerMax) && (!this.form.sdkVer && !this.form.sdkVerMax)) {
              return callback(new Error("APP版本与SDK版本必填一项"));
            }
            // 只能填正整数
            if (!Number.isInteger(this.form.appVer) || !Number.isInteger(this.form.appVerMax)) {
              return callback(new Error("请输入正整数"));
            }
            // 最小版本不能大于最大版本
            if (this.form.appVer > this.form.appVerMax) {
              return callback(new Error("最小版本不能大于最大版本"));
            }
            callback();
          },
        }],
        sdkVer: [{
          required: false, trigger: "blur",
          validator: (rule, value, callback) => {
            if ((!this.form.appVer && !this.form.appVerMax) && (!this.form.sdkVer && !this.form.sdkVerMax)) {
              return callback(new Error("APP版本与SDK版本必填一项"));
            }
            // 只能填正整数
            if (!Number.isInteger(this.form.sdkVer) || !Number.isInteger(this.form.sdkVerMax)) {
              return callback(new Error("请输入正整数"));
            }
            // 最小版本不能大于最大版本
            if (this.form.sdkVer > this.form.sdkVerMax) {
              return callback(new Error("最小版本不能大于最大版本"));
            }
            callback();
          },
        }],
        fileUrl: [{ required: true, message: "请上传插件", trigger: "blur" }],
      },
    };
  },

  methods: {
    //^ ^--------------保存-------------^ ^
    /** 确认 */
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log("form", this.form);
          const params = handleAddData(this.form)
          console.log("params", params);
          const { data } = await addPlugins(params);
          console.log("创建插件的响应", data);
          if (data.code === 200) {
            Message.success("创建成功");
            this.loadList();
            this.hide();
          }
        }
      });
    },
    //^ ^--------------上传相关-------------^ ^
    /** 上传校验 */
    checkUpload(file) {
      console.log("file", file);
      // 判断类型
      if (!this.validMimeTypes.includes(file.type)) {
        Message.error("请上传zip文件");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 50) {
        Message.error("不能上传超过50M的文件");
        return false;
      }
    },
    /** 上传的方法 */
    async upload(params) {
      console.log("上传的参数", params);
      const file = params.file;
      console.log("上传的文件", file);
      this.ossUpload(params);
    },
    async ossUpload(params) {
      try {
        this.currentUploadFileName = params.file.name
        const lastDotIndex = params.file.name.lastIndexOf(".");
        this.uploadBtnLoading = true;

        const options = {
          meta: { temp: "demo" },
          mime: "application/zip",
          headers: {
            "Content-Type": "application/zip"
          },
        };
        // 使用 moment 格式化日期
        const formattedDate = moment().format('YYYY-MM-DD');

        // 获取当前时间戳
        const timestamp = moment().valueOf();

        // 构建新的文件名
        const newFileName = `${formattedDate}/chengz/${timestamp}${params.file.name.substring(params.file.name.lastIndexOf('.'))}`;
        console.log("newFileName", newFileName);
        const client = new OSS({
          region: "oss-cn-shenzhen",
          accessKeyId: this.aliyunAkSk.value.accessKeyId, // 使用 inject 的 aliyunAkSk
          accessKeySecret: this.aliyunAkSk.value.accessKeySecret,
          bucket: "lebotob",
          timeout: 1000 * 60 * 30,
        });
        const result = await client.put(
          `/images/sdk/plugins/${newFileName}`,
          params.file,
          options
        );
        console.log('上传的响应', result);
        if (result.res.status === 200) {
          this.uploadBtnLoading = false;
          console.log("lastDotIndex", lastDotIndex, params.file.name);
          const fileSize = params.file.size
          this.form.fileUrl = result.url;
          this.form.fileMd5 = result.res.headers.etag
          this.form.fileSize = String(fileSize)
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (e) {
        this.uploadBtnLoading = false;
        console.log(e);
      }
    },
    //^ ^--------------对话框自身的方法-------------^ ^
    show() {
      this.dialog.visible = true;
    },
    hide() {
      this.dialog.visible = false;
    },
    /** 关闭 */
    closed() {
      this.dialog.visible = false;
      // 重置表单
      this.form.code = "";
      this.form.name = "";
      this.form.descr = "";
      this.form.ver = "";
      this.form.fileSize = "";
      this.form.appVer = "";
      this.form.appVerMax = "";
      this.form.sdkVer = "";
      this.form.sdkVerMax = "";
      this.form.fileMd5 = "";
      this.form.fileUrl = "";
      this.currentUploadFileName = "";
      // 清空表单验证规则
      this.$refs.form.clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input-number /deep/ .el-input__inner {
  text-align: center;
  /* 将数字内容右对齐 */
}

.is-error /deep/ .el-input-number__decrease,
.is-error /deep/ .el-input-number__increase,
.is-success /deep/ .el-input-number__decrease,
.is-success /deep/ .el-input-number__increase {
  right: 1px !important;
}
</style>
